
















































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SuporteAlterarSituacaoSolicitacaoStore, { SituacaoEtapa } from '@/components/Suporte/Store/SuporteAlterarSituacaoSolicitacaoStore'
import HistoricoSolicitacaoStore from '@/components/HistoricoSolicitacao/Store/HistoricoSolicitacaoStore'
import { DataTablePagination, AgendamentoSolicitacaoItem } from '@/types/_'
import { displayColorBySituation, humanTime } from '@/utils/common'
import _ from 'lodash'
import { useHospitais } from '@/composables'

@Component({
  filters: { humanTime },
})

export default class ViewSuporteAlterarSituacaoSolicitacao extends Vue {
  loadHistorico: string = ''
  loadFilter: boolean = false
  loadSolicitacoes: boolean = false
  searched: boolean = false

  get getSuporteAlterarSituacaoSolicitacaoStore() {
    return getModule(SuporteAlterarSituacaoSolicitacaoStore, this.$store)
  }

  get getHistoricoSolicitacaoStore() {
    return getModule(HistoricoSolicitacaoStore, this.$store)
  }

  get loadingHistorico() { return this.loadHistorico }
  set loadingHistorico(value: string) { this.loadHistorico = value }
  get hospitalId() { return this.getSuporteAlterarSituacaoSolicitacaoStore.hospitalId }
  set hospitalId(value: string) { this.getSuporteAlterarSituacaoSolicitacaoStore.setHospitalId(value) }
  get hospitais() {
    return useHospitais.hospitaisByCurrentUser.map((h) => {
      const hospital = h
      hospital.id = _.toUpper(h.id)
      hospital.nome = _.toUpper(h.nome)
      return hospital
    })
  }

  fetchHospitais() {
    return useHospitais.loadHospitaisByCurrentUser()
  }

  get loadingFilter() { return this.loadFilter }
  set loadingFilter(value: boolean) { this.loadFilter = value }

  get loadingSolicitacoes() { return this.loadSolicitacoes }
  set loadingSolicitacoes(value: boolean) { this.loadSolicitacoes = value }

  get pacienteSearch() { return this.getSuporteAlterarSituacaoSolicitacaoStore.pacienteSearch }
  set pacienteSearch(value: any) { this.getSuporteAlterarSituacaoSolicitacaoStore.setPacienteSearch(!['', null, undefined].includes(value) ? value : '') }

  get numeroAgendamentoSearch() { return this.getSuporteAlterarSituacaoSolicitacaoStore.numeroAgendamentoSearch }
  set numeroAgendamentoSearch(value: any) { this.getSuporteAlterarSituacaoSolicitacaoStore.setNumeroAgendamentoSearch(!['', null, undefined].includes(value) ? value : '') }

  get solicitacaoIdSearch() { return this.getSuporteAlterarSituacaoSolicitacaoStore.solicitacaoIdSearch }
  set solicitacaoIdSearch(value: any) { this.getSuporteAlterarSituacaoSolicitacaoStore.setSolicitacaoIdSearch(!['', null, undefined].includes(value) ? value : '') }

  get solicitacoes() { return this.getSuporteAlterarSituacaoSolicitacaoStore.solicitacoes }
  get paginationSolicitacoes() { return this.getSuporteAlterarSituacaoSolicitacaoStore.paginationSolicitacoes }
  get statusSituacaoEtapa() { return this.getSuporteAlterarSituacaoSolicitacaoStore.statusSituacaoEtapa }
  
  async filterSolicitacoes() {
    this.loadingFilter = true
    this.loadingSolicitacoes = true
    this.searched = true
    if (!this.statusSituacaoEtapa || this.statusSituacaoEtapa.length === 0) {
      await this.getSuporteAlterarSituacaoSolicitacaoStore.getAllStatusSituacaoEtapa()
    }
    await this.getSuporteAlterarSituacaoSolicitacaoStore.getAllSolicitacoes(this.paginationSolicitacoes)
    this.loadingSolicitacoes = false
    this.loadingFilter = false
  }

  clearFilters() {
    this.getSuporteAlterarSituacaoSolicitacaoStore.setPacienteSearch('')
    this.getSuporteAlterarSituacaoSolicitacaoStore.setNumeroAgendamentoSearch('')
    this.getSuporteAlterarSituacaoSolicitacaoStore.setSolicitacaoIdSearch('')
  }

  async hospitalChange(id: any) {
    this.clearFilters()
    this.getSuporteAlterarSituacaoSolicitacaoStore.setHospitalId(id)
    this.getSuporteAlterarSituacaoSolicitacaoStore.clearSolicitacoes()
    this.searched = false
  }

  async updatePaginationSolicitacoes(pagination: DataTablePagination) {
    if (['', null, undefined].includes(this.hospitalId)) return
    if (this.loadingFilter) return
    this.loadingSolicitacoes = true
    await this.getSuporteAlterarSituacaoSolicitacaoStore.getAllSolicitacoes(pagination)
    this.loadingSolicitacoes = false
  }

  get solicitacoesHeaders() {
    return [
      { text: 'Paciente', value: 'pacienteNome', sortable: false },
      { text: 'Nº da reserva', value: 'numeroAgendamento', sortable: false },
      { text: 'Etapa', value: 'etapa', sortable: false },
      { text: 'Situação', value: 'situacao', sortable: false },
      { text: 'Data de envio', value: 'dataEnvio', align: 'left', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  disableSituacaoChange(situacao: string) {
    return this.getSuporteAlterarSituacaoSolicitacaoStore.situacoesNaoPermitidas.includes(situacao)
  }

  displayCorSituacao(value: string) {
    return displayColorBySituation(value)
  }

  editarSituacao(item: AgendamentoSolicitacaoItem) {
    const { statusSituacaoEtapa, statusConfiguracaoDefault } = this.getSuporteAlterarSituacaoSolicitacaoStore
    const situacaoEtapa = statusSituacaoEtapa.find((s: SituacaoEtapa) => item.situacao.key === s.situacao && item.etapa.key === s.etapa)
    this.getSuporteAlterarSituacaoSolicitacaoStore.setStatusSituacaoConfiguracao(situacaoEtapa || statusConfiguracaoDefault)
    this.getSuporteAlterarSituacaoSolicitacaoStore.setSolicitacaoId(item.id)
    this.getSuporteAlterarSituacaoSolicitacaoStore.setModal({ name: 'alterarSituacaoSolicitacao', value: true })
  }

  async showHistory(solicitacaoId: string) {
    this.loadingHistorico = solicitacaoId
    await this.getHistoricoSolicitacaoStore.getHistoricoSolicitacao(solicitacaoId)
    this.loadingHistorico = ''
  }

  beforeDestroy() {
    this.getSuporteAlterarSituacaoSolicitacaoStore.clearSolicitacoes()
    this.getSuporteAlterarSituacaoSolicitacaoStore.clearHospitalId()
  }
}
